__turbopack_context__.v({
  "Location": "OfficeLocationsCarousel-module-scss-module__pPa0OW__Location",
  "Slide": "OfficeLocationsCarousel-module-scss-module__pPa0OW__Slide",
  "Swiper": "OfficeLocationsCarousel-module-scss-module__pPa0OW__Swiper",
  "Title": "OfficeLocationsCarousel-module-scss-module__pPa0OW__Title",
  "swiper-wrapper": "OfficeLocationsCarousel-module-scss-module__pPa0OW__swiper-wrapper",
});
